import { render, staticRenderFns } from "./VvBoxItem.vue?vue&type=template&id=45172111&scoped=true&"
import script from "./VvBoxItem.vue?vue&type=script&lang=js&"
export * from "./VvBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./VvBoxItem.vue?vue&type=style&index=0&id=45172111&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45172111",
  null
  
)

export default component.exports